<script setup lang="ts">
import Icon from '@/components/Icon.vue';
defineProps<{ href: string; title: string; subtitle?: string; external?: boolean; icon: string }>();
</script>

<template>
    <a
        :href="href"
        class="cb-item"
        :target="external ? '_blank' : undefined"
        :rel="external ? 'noopener' : undefined"
    >
        <span class="cb-ico">
            <Icon :name="icon" />
        </span>
        <div class="min-w-0">
            <p class="cb-title">{{ title }}</p>
            <p v-if="subtitle" class="cb-sub truncate">{{ subtitle }}</p>
        </div>
    </a>
</template>

<style scoped>
.cb-item {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.65rem 0.85rem;
    transition:
        background-color 0.15s ease,
        transform 0.12s ease;
}
.cb-item:hover {
    background: #f3f6ff;
} /* clearer hover */
.cb-item:active {
    background: #e9efff;
    transform: translateY(0);
}

.cb-ico {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 9999px;
    color: #1d4ed8; /* stronger glyph */
    background: linear-gradient(180deg, #eef3ff, #e7eeff);
    border: 1px solid #c8d6fb; /* visible edge */
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);
    margin-top: 2px;
}
.cb-title {
    margin: 0;
    font-size: 13.5px;
    line-height: 1.34;
    font-weight: 600;
    color: #0b1220; /* darker title */
}
.cb-sub {
    margin: 0.15rem 0 0 0;
    font-size: 12.5px;
    line-height: 1.25;
    color: #475569;
}

@media (max-width: 640px) {
    .cb-title {
        font-size: 14px;
        line-height: 1.35;
    }
    .cb-sub {
        font-size: 13px;
        line-height: 1.3;
        letter-spacing: 0;
    }
}

@media (hover: none) and (pointer: coarse)  {
    .cb-item:hover,
    .cb-item:active {
        background: #f3f6ff;
        transform: none !important;
    }
}
</style>
